<template>
  <div :class="{ 'group_active': active, 'group_blur': !active }" class="group">
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.group {
  will-change: transform, opacity, filter;
  height: $notification-group-height;
  position: absolute;
  &_active {
    left: 50%;
    top: 50%;
    margin-left: -310px/2;
    margin-top: -$notification-group-height/2;
    will-change: transform, opacity, filter;
    z-index: 2;
  }
  &_blur {
    left: 50%;
    top: 85%;
    will-change: transform, opacity, filter;
    filter: progid:DXImageTransform.Microsoft.Blur(pixelRadius=3);
    filter: blur(3px);
    -moz-filter: blur(3px);
    -o-filter: blur(3px);
    -ms-filter: blur(3px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlatformNotifications/PlatformNotificationsGroup.vue